import "../styles/embed-notification-bell.scss";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import actions from "../actions/actions";
import Popover from "./popover";
import EmbedNotificationPanel from "./embed-notification-panel";
import { useUpdateState } from "../utilities/utilities";

const PollIntervalMs = 60000;

export default function EmbedNotificationBell({ ready = true }) {
  let [state, updateState] = useUpdateState({ showNotifications: false });
  let unreadCount = useSelector(
    (store) => store.embedNotifications.unreadCount,
  );

  useEffect(() => {
    if (!ready) return;
    actions.embedNotifications.pollUnreadCount();
    const interval = setInterval(
      actions.embedNotifications.pollUnreadCount,
      PollIntervalMs,
    );
    return () => clearInterval(interval);
  }, [ready]);

  function handleBellClick() {
    if (!state.showNotifications) {
      actions.embedNotifications.fetchList();
    }
    updateState({ showNotifications: !state.showNotifications });
  }

  return (
    <div
      className={
        "embed-bell-btn" +
        (state.showNotifications ? " embed-bell-btn--open" : "")
      }
      onClick={handleBellClick}
      role="button"
      tabIndex={0}
      aria-label="Notifications"
    >
      <i className="fas fa-bell" />
      {unreadCount > 0 && (
        <div className="embed-bell-badge">
          {unreadCount > 99 ? "99+" : unreadCount}
        </div>
      )}
      <Popover
        show={state.showNotifications}
        onHide={() => updateState({ showNotifications: false })}
        className="embed-notif-popover"
      >
        <EmbedNotificationPanel
          onClose={() => updateState({ showNotifications: false })}
        />
      </Popover>
    </div>
  );
}
